// [ai] A structural signature of the shell's chrome (tags + classes, no text, no hrefs, no state attributes): the E2E asserts it is
// identical on every route — one bar, one navigation, one dock, one player host, one player layer (present, its contents are state:
// the folders card on /browse, the open drop), whatever page is inside.
const CHROME = [".at-bar", ".at-side", ".at-dock", ".at-player-host"];
function sig(el: Element): string {
  const cls = [...el.classList].filter(c => !/^(on|open|in|out|playing|skipping|looping|has-quote|panel-open|note-only|drag|dragging|flash|free|page|search|note|past|cur|q|err|saved|off|ch|radio)$/.test(c)).sort().join(".");
  const kids = [...el.children].map(sig).join(",");
  return `${el.tagName.toLowerCase()}${cls ? "." + cls : ""}${kids ? `[${kids}]` : ""}`;
}
export function chromeSignature(root: ParentNode = document): string {
  return [...CHROME.map(s => { const el = root.querySelector(s); return el ? sig(el) : `${s}:absent`; }), root.querySelector("#ds-layer") ? "#ds-layer" : "#ds-layer:absent"].join(">");
}
